export const HEADERS = {
  home: 'HOME',
  aboutUs: 'ABOUT US',
  whyUs: 'WHY US?',
  products: 'PRODUCTS',
  getInTouch: 'GET IN TOUCH',
};
